import type { ElementType, ReactNode } from 'react';

import { cn } from '@/lib/utils';

type RowListProps = {
  as?: ElementType;
  'aria-label'?: string;
  children: ReactNode;
  className?: string;
};

/**
 * Hub-style grouped rows: rounded block, divide-y, ring. Children should be interactive rows
 * (`Link`, `button`, or anchors) — not `<li>` unless you wrap the list semantically yourself.
 */
export function RowList({
  as: Tag = 'section',
  'aria-label': ariaLabel,
  children,
  className,
}: RowListProps) {
  return (
    <Tag
      aria-label={ariaLabel}
      className={cn(
        'border-fin-gray-800 bg-fin-gray-900/40 ring-fin-gray-800/30 overflow-hidden rounded-xl border ring-1',
        className
      )}
    >
      <div className='divide-fin-gray-800/60 divide-y'>{children}</div>
    </Tag>
  );
}
